module.exports = __webpack_public_path__ + "img/Referenzen_Security13.104eb66e.jpg";